export const url_endpoint = "//postcastbackend.nossavoz.rec.br/api/";
//export const url_endpoint = "http://localhost:8081/api/";
// export const url_s3 = "https://s3.amazonaws.com/postcast.estatios.homolog/";
export const url_s3 = "https://s3-sa-east-1.amazonaws.com/postcast.estaticos/";
export const urlVideo =
  "//postcast-front.s3.amazonaws.com/static/videos/video.mp4";
export const urlPlayer = "https://player.blogplay.com.br";
export const urlPlayerPreview = 'https://player.blogplay.com.br/player/'
//export const urlPlayerPreview = 'http://testeplayer.s3-website-us-east-1.amazonaws.com/'
export const urlTTSPlayerPreview = 'https://plug.blogplay.com.br/?preview=true'

export const baseUrlPlugPlayer = 'https://plug.blogplay.com.br'

// 0 - Blogplay
// 1 - Plug
export const clientTypes = ['Blogplay', 'Plug']
export const blogPlayClientType = 0
export const plugClientType = 1

// In mb
export const maxAudioTracksSize = 3

export const lowestCampaignPriority = 0
export const highestCampaignPriority = 5
export const maxAudiosPerCampaign = 5
// In mb
export const maxSizeAudioCampaign = 3
// In s
export const maxDurationAudioCampaign = 15

export const defaultPaperPadding = '26px 24px'

export const tableRowBackground = 'rgba(156, 156, 156, 0.05)'